module.exports = __webpack_public_path__ + "img/money.4d7a8057.svg";